import { costBreakupService } from '../../services';

interface IConfig {
  getDatabaseReport: (params: any) => Promise<any>;
  getDataTransferReport: (params: any) => Promise<any>;
  getInstanceCostReport: (params: any) => Promise<any>;
  getContainersReport: (params: any) => Promise<any>;
  getStorageReport: (params: any) => Promise<any>;
  getCloudwatchReport: (params: any) => Promise<any>;
  getNetworkDeliveryReport: (params: any) => Promise<any>;
  getSecurityReport: (params: any) => Promise<any>;
  getServerlessReport: (params: any) => Promise<any>;
  getAnalyticsReport: (params: any) => Promise<any>;
  getMigrationTransferReport: (params: any) => Promise<any>;
  getMediaServicesReport: (params: any) => Promise<any>;
  downloadInstanceCostReport: (params: any) => Promise<any>;
  downloadContainersReport: (params: any) => Promise<any>;
  downloadStorageReport: (params: any) => Promise<any>;
  downloadCloudwatchReport: (params: any) => Promise<any>;
  downloadNetworkDeliveryReport: (params: any) => Promise<any>;
  downloadSecurityReport: (params: any) => Promise<any>;
  downloadServerlessReport: (params: any) => Promise<any>;
  downloadAnalyticsReport: (params: any) => Promise<any>;
  downloadMigrationTransferReport: (params: any) => Promise<any>;
  downloadMediaServicesReport: (params: any) => Promise<any>;
}

export const config: IConfig = {
  getDataTransferReport: (params: any) =>
    costBreakupService.getDataTransferReport(params),
  getDatabaseReport: (params: any) =>
    costBreakupService.getDatabaseReport(params),
  getInstanceCostReport: (params: any) =>
    costBreakupService.getInstanceCostReport(params),
  getContainersReport: (params: any) =>
    costBreakupService.getContainersReport(params),
  getStorageReport: (params: any) =>
    costBreakupService.getStorageReport(params),
  getCloudwatchReport: (params: any) =>
    costBreakupService.getCloudwatchReport(params),
  getNetworkDeliveryReport: (params: any) =>
    costBreakupService.getNetworkDeliveryReport(params),
  getSecurityReport: (params: any) =>
    costBreakupService.getSecurityReport(params),
  getServerlessReport: (params: any) =>
    costBreakupService.getServerlessReport(params),
  getAnalyticsReport: (params: any) =>
    costBreakupService.getAnalyticsReport(params),
  getMigrationTransferReport: (params: any) =>
    costBreakupService.getMigrationTransferReport(params),
  getMediaServicesReport: (params: any) =>
    costBreakupService.getMediaServicesReport(params),
  downloadInstanceCostReport: (params: any) =>
    costBreakupService.downloadInstanceCostReport(params),
  downloadContainersReport: (params: any) =>
    costBreakupService.downloadContainersReport(params),
  downloadStorageReport: (params: any) =>
    costBreakupService.downloadStorageReport(params),
  downloadCloudwatchReport: (params: any) =>
    costBreakupService.downloadCloudwatchReport(params),
  downloadNetworkDeliveryReport: (params: any) =>
    costBreakupService.downloadNetworkDeliveryReport(params),
  downloadSecurityReport: (params: any) =>
    costBreakupService.downloadSecurityReport(params),
  downloadServerlessReport: (params: any) =>
    costBreakupService.downloadServerlessReport(params),
  downloadAnalyticsReport: (params: any) =>
    costBreakupService.downloadAnalyticsReport(params),
  downloadMigrationTransferReport: (params: any) =>
    costBreakupService.downloadMigrationTransferReport(params),
  downloadMediaServicesReport: (params: any) =>
    costBreakupService.downloadMediaServicesReport(params),
};
